<sk-modal-content
  [title]="'label.AddNewFolder' | translate | uppercase"
  (closed)="closeWithoutResult()"
  confirmByKeypress
  (confirmed)="onSubmit()"
  (cancelled)="closeWithoutResult()"
  [allowCancelIfChildFocused]="true"
  [allowConfirmIfChildFocused]="true"
>
  <ng-container id="sk-modal-body">
    <form [formGroup]="addFolderForm" class="pb-3">
      <sk-text
        [label]="'label.FolderName' | translate"
        data-test="folder-add-modal_name"
        formControlName="name"
      ></sk-text>
    </form>
  </ng-container>
  <ng-container id="sk-modal-footer-buttons">
    <sk-button
      [color]="'primary'"
      [loadingBtn]="duplicateChecking()"
      (click)="onSubmit()"
      [disabled]="addFolderForm.invalid"
      data-test="folder-add-modal_submit-button"
      [label]="'label.Create' | translate"
    >
      <ng-template buttonPrefix>
        <i class="fas fa-check"></i>
      </ng-template>
    </sk-button>
  </ng-container>
</sk-modal-content>
